import {
  Venue,
  Promoter,
  Ticket,
  ExternalAccount,
  Subscription,
} from '../types';

export const mockVenues: Venue[] = [
  {
    id: 1,
    venue_id: 'brooklyn-steel',
    name: 'Brooklyn Steel',
    slug: 'brooklyn-steel',
    address: '319 Frost St',
    city: 'Brooklyn',
    state: 'NY',
    country: 'US',
    capacity: 1800,
    venue_url: 'https://dice.fm/venue/brooklyn-steel',
    timezone: 'America/New_York',
    is_popular: true,
    is_subscribed: false,
  },
  {
    id: 2,
    venue_id: 'terminal-5',
    name: 'Terminal 5',
    slug: 'terminal-5',
    address: '610 W 56th St',
    city: 'New York',
    state: 'NY',
    country: 'US',
    capacity: 3000,
    venue_url: 'https://dice.fm/venue/terminal-5',
    timezone: 'America/New_York',
    is_popular: true,
    is_subscribed: true,
  },
  {
    id: 3,
    venue_id: 'bowery-ballroom',
    name: 'Bowery Ballroom',
    slug: 'bowery-ballroom',
    address: '6 Delancey St',
    city: 'New York',
    state: 'NY',
    country: 'US',
    capacity: 575,
    venue_url: 'https://dice.fm/venue/bowery-ballroom',
    timezone: 'America/New_York',
    is_popular: false,
    is_subscribed: false,
  },
];

export const mockPromoters: Promoter[] = [
  {
    id: 1,
    promoter_id: 'live-nation',
    name: 'Live Nation',
    slug: 'live-nation',
    promoter_url: 'https://dice.fm/promoter/live-nation',
    image_url: 'https://via.placeholder.com/150',
    is_subscribed: false,
  },
  {
    id: 2,
    promoter_id: 'bowery-presents',
    name: 'Bowery Presents',
    slug: 'bowery-presents',
    promoter_url: 'https://dice.fm/promoter/bowery-presents',
    image_url: 'https://via.placeholder.com/150',
    is_subscribed: true,
  },
];

export const mockTickets: Ticket[] = [
  {
    id: 123,
    external_ticket_id: 'dice_abc123',
    platform: 'dice',
    ticket_status: 'active',
    event_name: 'KAYTRANADA',
    venue_name: 'Brooklyn Steel',
    event_date: '2025-12-15T20:00:00Z',
    external_platform_connection: {
      id: 1,
      platform: 'DICE',
      email: 'user@example.com',
    },
    ticket_metadata: {
      id: 'dice_abc123',
      cost: { amount: 45.0, currency: 'USD' },
      ticket_holder: { first_name: 'John', last_name: 'Doe' },
      type: { id: 1, name: 'General Admission' },
      simple_code: 'ABC12',
    },
  },
  {
    id: 124,
    external_ticket_id: 'axs_def456',
    platform: 'axs',
    ticket_status: 'active',
    event_name: 'The Weeknd',
    venue_name: 'Madison Square Garden',
    event_date: '2025-12-20T19:30:00Z',
    external_platform_connection: {
      id: 2,
      platform: 'AXS',
      email: 'user@example.com',
    },
    ticket_metadata: {
      id: 'axs_def456',
      cost: { amount: 250.0, currency: 'USD' },
      ticket_holder: { first_name: 'John', last_name: 'Doe' },
      type: { id: 2, name: 'Floor Seats - Section A' },
    },
  },
];

export const mockAccounts: ExternalAccount[] = [
  {
    id: 789,
    platform: 'DICE',
    email: 'user@example.com',
    phone_masked: '***7890',
    is_active: true,
    connected_at: '2025-11-24T10:30:00Z',
    last_synced: '2025-11-24T11:00:00Z',
  },
];

export const mockSubscriptions: Subscription[] = [
  {
    id: 456,
    type: 'venue',
    entity_id: 'terminal-5',
    entity_name: 'Terminal 5',
    entity_details: {
      city: 'New York',
      capacity: 3000,
    },
    created_at: '2025-11-24T10:30:00Z',
  },
  {
    id: 457,
    type: 'promoter',
    entity_id: 'bowery-presents',
    entity_name: 'Bowery Presents',
    entity_details: {
      slug: 'bowery-presents',
    },
    created_at: '2025-11-23T14:20:00Z',
  },
];


